/* @flow */
import { useEffect, useRef } from 'react';

// This hook preserves the document returned from '/ws/checkout-v2/invoice' (if any)
// but keeps clearing it when the Document Type changes (if there was no document to begin with).
export function useInvoiceDocumentPreservation(
  documentValue: ?string,
  setDocument: (string) => mixed,
  trigger: mixed,
): boolean {
  const skipRef = useRef(true);
  const hasInvoiceDocumentRef = useRef<?boolean>(null);

  if (hasInvoiceDocumentRef.current === null) {
    hasInvoiceDocumentRef.current = Boolean(documentValue);
  }

  useEffect(() => {
    if (skipRef.current) {
      skipRef.current = false;
      return;
    }
    if (hasInvoiceDocumentRef.current === false) {
      setDocument('');
    }
  }, [setDocument, trigger]);

  return hasInvoiceDocumentRef.current ?? false;
}
